export default {
    returnToWig: 'Return to wig',
    optionalID: 'ID (Optional)',
    includeVAT: 'Include VAT',
    selectPaymentType: 'Select payment type',
    enterFirstAmount: 'Enter first amount',
    enterAmount: 'Enter amount',
    totalAmount: 'Total amount',
    commentForPaymentType: 'Comment for payment type',
    selectBankCode: 'Select bank code',
    enterCheckNumber: 'Enter check number',
    enterBranchNumber: 'Enter branch number',
    enterBankAccountNumber: 'Enter bank account number (last 4)',
    enterERNReferenceNumber: 'ERN Reference Number',
    enterFullBankAccountNumber: 'Enter bank account number',
    quantityOfPayments: 'Enter quanity of payments',
    addPayment: 'Add payment',
    save: 'Save Payment',
    addAnotherCheck: 'Add another check',
    confirmWithoutOptionalID:
        'Are you sure you want to continue without Optional ID?',
    saveWithRivhitPaymentSystem: 'Save with RIVHIT payment system?',
    saveWithRivhit: 'Save with RIVHIT',
    saveOnlyLocally: 'Save only locally',
    enterDescription: 'Enter description',
    paymentProcessing: 'Payment processing for:',
    fieldIsRequired: 'This field is required',
    dueDate: 'Due date',
    firstName: 'First Name',
    lastName: 'Last name',
    clientsName: 'Clients Name',
    taxInvoiceAndReceipt: 'Tax invoice and receipt',
    confirm: 'Confirm',
    checkFields: 'Check if all required fields are filled',
    paymentType: 'Payment type',
    paymentSavedLocally: 'The payment saved locally',
    paymentSavedWithRivhit: 'The payment saved with rivhit',
    errorSavingPayment: 'Error saving payment',
    receiptOnly: 'Receipt only',
    optionalIdDigits: 'Must be 9 digits',
    ['שיק']: 'Check',
    ['מזומן']: 'Cash',
    ['ישראכרט']: 'Isracard',
    ['ויזה']: 'Visa',
    ['כ אשראי אחר']: 'Other Credit Card',
    ['דיינרס']: 'Diners',
    ['אמקס']: 'Amex',
    ['העברה בנקאית']: 'Bank Transfer',
    ['הוראת קבע בנקאית']: 'Bank Direct Debit',
    ['מאסטרכארד']: 'Mastercard',
    ['בנק שלי']: 'My Bank',
    ['יורו טרייד']: 'Euro Trade',
    ['צפון אמריקאי']: 'North American',
    ['יהב']: 'Yahav',
    ['בנק מזרחי טפחות']: 'Mizrahi Tefahot Bank',
    ['לפתוח התעשריה']: 'Financial Development',
    ['הספנות']: 'Shipping',
    ['הדואר']: 'Postal Bank',
    ['לאומי']: 'Leumi',
    ['דיסקונט']: 'Discount Bank',
    ['הפועלים']: 'Hapoalim',
    ['איגוד']: 'Igud',
    ['אוצר החייל']: 'Otzar Hahayal',
    ['מרכנתיל דיסקונט']: 'Mercantile Discount',
    ['One Zero']: 'One Zero',
    ['החקלאות לישראל']: 'Agricultural Bank of Israel',
    ['מזרחי טפחות']: 'Mizrahi Tefahot',
    ['אמריקאי ישראלי']: 'American Israeli',
    ['כללי']: 'General',
    ['קונטיננטל ישראל']: 'Continental Israel',
    ['הבינלאומי הראשון']: 'First International',
    ['מימון וסחר']: 'Finance & Trade',
    ['ערבי ישראלי']: 'Arab-Israeli',
    ['בנק פאגאקו']: 'Pagako Bank',
    ['מסד']: 'Masad',
    ['בנק עולמי']: 'World Bank',
    ['פאג"י']: 'Pagi',
    ['עליה']: 'Aliya',
    ['ירושלים']: 'Jerusalem',
    ['בנק ישראל']: 'Bank of Israel',
    enterCheckAmount: 'Enter check amount',
    fillAllRequiredFields: 'Please fill all required fields before adding payment',
    multiplePayments: 'Multiple',
    bankDirectDebit: 'Bank Direct Debit',
}
